import { render } from "./profiles.vue?vue&type=template&id=35195b9a"
import script from "./profiles.vue?vue&type=script&lang=js"
export * from "./profiles.vue?vue&type=script&lang=js"

import "./profiles.vue?vue&type=style&index=0&id=35195b9a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__